/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSimpleSummary } from '../../models/sales-article-simple-summary';

export interface ApiProductsquerySalesarticlesQuickSearchGet$Params {
  searchTerm?: string;
}

export function apiProductsquerySalesarticlesQuickSearchGet(http: HttpClient, rootUrl: string, params?: ApiProductsquerySalesarticlesQuickSearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSimpleSummary>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsquerySalesarticlesQuickSearchGet.PATH, 'get');
  if (params) {
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleSimpleSummary>>;
    })
  );
}

apiProductsquerySalesarticlesQuickSearchGet.PATH = '/api/productsquery/salesarticles/quick-search';
